import { renderToStaticMarkup } from 'react-dom/server'
import pdfMake from 'pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts"
import htmlToPdfMake from 'html-to-pdfmake'
import pdfMerger from 'pdf-merger-js/browser'

import Template from 'views/reports/Template'
import invoicePdfDocDefinition from 'components/invoice/invoiceDocDefinition'


pdfMake.vfs = pdfFonts.pdfMake.vfs

export default () => {

    /**
     * Generates pdf of report data
     * @param data Report data for request
     * @returns Pdf report as a Buffer
     */
    const generateOutputPdfBuffer = async (data) => {
        const { insurerCode, formCode, title, formData } = data

        // Get the react component for the output template
        const template = (
            <Template
                insurerCode={insurerCode}
                formCode={formCode}
                data={formData}
            />
        )

        // Generate html from the react component
        const templateAsHtml = renderToStaticMarkup(template)

        // Configure pdf metadata
        const pdfInfo = { title: title }

        // Generate the PDF from the html
        const pdfContent = htmlToPdfMake(templateAsHtml, pdfOptions)
        const dd = { info: pdfInfo, content: pdfContent }
        const pdf = pdfMake.createPdf(dd)

        // Get the PDF as a buffer
        const buffer = await getBuffer(pdf)

        // Return the buffer
        return buffer
    }

    /**
     * Wraps third party callback based function getBuffer, so it can be called as a promise based function
     * @param pdf Third party pdf object
     * @returns Promise based result of calling getBuffer function
     */
    const getBuffer = (pdf) => {
        return new Promise((resolve, reject) => {
            try {
                pdf.getBuffer(buffer => resolve(buffer))
            } catch (error) {
                reject(error)
            }
        })
    }

    /**
     * Merge multiple pdfs into one.
     * @param buffers Accepts an array of Buffers
     * @param title Title of the
     * @returns A single Buffer
     */
    const mergePdfs = async (buffers, title) => {
        const merger = new pdfMerger()

        for (const buffer of buffers) {
            await merger.add(buffer)
        }

        await merger.setMetadata({ title: title });

        return await merger.saveAsBuffer()
    }

    /**
     * Generates pdf using from supplied data & invoice template
     * @param data Invoice data for request
     * @param callback Callback to receive pdf in base64 format
     */
    const generateInvoicePdf = (data, callback) => {
        // Generate the document definition using the data
        const dd = invoicePdfDocDefinition(data)

        // Generate the PDF from the document definition
        const pdf = pdfMake.createPdf(dd)

        // Get base 64 string from the PDF
        pdf.getBase64(base64 => callback(base64))
    }

    const pdfOptions = {
        defaultStyles: {
            // Override default element styles that are defined below
            b: { bold: true },
            strong: { bold: true },
            u: { decoration: 'underline' },
            del: { decoration: 'lineThrough' },
            s: { decoration: 'lineThrough' },
            em: { italics: true },
            i: { italics: true },
            h1: { fontSize: 24, bold: true, marginBottom: 5 },
            h2: { fontSize: 22, bold: true, marginBottom: 5 },
            h3: { fontSize: 20, bold: true, marginBottom: 5 },
            h4: { fontSize: 18, bold: true, marginBottom: 5 },
            h5: { fontSize: 16, bold: true, marginBottom: 5 },
            h6: { fontSize: 14, bold: true, marginBottom: 5 },
            a: { color: 'blue', decoration: 'underline' },
            strike: { decoration: 'lineThrough' },
            p: { margin: [0, 5, 0, 10] },
            ul: { marginBottom: 5, marginLeft: 5 },
            table: { width: '*', marginBottom: 10, fontSize: 11 },
            th: { bold: true, fillColor: '#EEEEEE' }
        },
        tableAutoSize: true
    }

    return {
        generateOutputPdfBuffer,
        mergePdfs,
        generateInvoicePdf,
    }
}